import React from 'react';
import {
	Box,
	Button,
	Container,
	makeStyles
} from '@material-ui/core';

import Page from '../../components/Page';
import {useMsal} from "@azure/msal-react";
import {loginRequest} from "../../authConfig";

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.dark,
		height: '100%',
		paddingBottom: theme.spacing(3),
		paddingTop: theme.spacing(3)
	}
}));

const LoginView = () => {
	const classes = useStyles();
    const { instance } = useMsal();

	const handleSubmit = (e) => {
	    e.preventDefault();
	    instance.loginRedirect(loginRequest);
	};

	return (
		<Page
			className={classes.root}
			title="Login"
		>
			<Box
				display="flex"
				flexDirection="column"
				height="100%"
				justifyContent="center"
			>
				<Container maxWidth="sm">
					<form onSubmit={handleSubmit}>

						<Box my={2}>
							<Button
								color="primary"
								fullWidth
								size="large"
								type="submit"
								variant="contained"
							>
								Sign in now
							</Button>
						</Box>
					</form>
				</Container>
			</Box>
		</Page>
	);
};

export default LoginView;